﻿import type { DashboardSummary } from "@/types.ts";
interface DashboardQuickStatusProps {
    summary: DashboardSummary | null;
}
const DashboardQuickStatus = ({ summary }: DashboardQuickStatusProps) => {
    const activeEventCount = (summary?.openEmergencyEventCount ?? 0) +
        (summary?.acknowledgedEmergencyEventCount ?? 0) +
        (summary?.inProgressEmergencyEventCount ?? 0);
    const hasIssue = activeEventCount > 0 || (summary?.offlineDeviceCount ?? 0) > 0;
    const statusItems = [
        {
            label: "시스템 상태",
            value: hasIssue ? "확인 필요" : "정상 운영 중",
            icon: "ri-server-line",
            color: hasIssue ? "text-orange-600" : "text-emerald-600",
            bgColor: hasIssue ? "bg-orange-50" : "bg-emerald-50",
        },
        {
            label: "미처리 이벤트",
            value: `${activeEventCount}건`,
            icon: "ri-alarm-warning-line",
            color: activeEventCount > 0 ? "text-red-600" : "text-slate-600",
            bgColor: activeEventCount > 0 ? "bg-red-50" : "bg-slate-50",
        },
        {
            label: "오프라인 기기",
            value: `${summary?.offlineDeviceCount ?? 0}대`,
            icon: "ri-router-line",
            color: (summary?.offlineDeviceCount ?? 0) > 0 ? "text-blue-600" : "text-slate-600",
            bgColor: (summary?.offlineDeviceCount ?? 0) > 0 ? "bg-blue-50" : "bg-slate-50",
        },
    ];
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
      <div className="flex items-center gap-2 mb-3">
        <i className="ri-dashboard-3-line text-slate-500 text-sm"/>
        <h3 className="text-sm font-semibold text-slate-800">시스템 상태</h3>
      </div>

      <div className="space-y-2">
        {statusItems.map((item) => (<div key={item.label} className="flex items-center justify-between py-2">
            <div className="flex items-center gap-3">
              <div className={`flex items-center justify-center w-8 h-8 rounded ${item.bgColor}`}>
                <i className={`${item.icon} ${item.color} text-sm`}/>
              </div>
              <span className="text-sm text-slate-600">{item.label}</span>
            </div>
            <span className={`text-sm font-medium ${item.color}`}>{item.value}</span>
          </div>))}
      </div>

      <div className="mt-3 pt-3 border-t border-slate-100">
        <div className="flex items-center justify-between">
          <span className="text-xs text-slate-500">조회 상태</span>
          <span className="text-xs text-slate-700 font-medium">API 조회 완료</span>
        </div>
      </div>
    </div>);
};
export default DashboardQuickStatus;
